<template>
  <teleport to="body">
    <WdsModal :show="open" custom-size="550px" no-close-icon @cancel="emit('close')">
      <WdsStack direction-column gap-xs>
        <WdsText xl primary>
          {{ $t('Do you want to delete the request?') }}
        </WdsText>
      </WdsStack>

      <template #footer>
        <WdsStack justify-end gap-sm>
          <WdsButton :disabled="deletePaymentRequestLoading" @click="emit('close')">
            {{ $t('Cancel') }}
          </WdsButton>

          <WdsButton error :disabled="deletePaymentRequestLoading" @click="deletePaymentRequest">
            {{ $t('Delete') }}
          </WdsButton>
        </WdsStack>
      </template>
    </WdsModal>
  </teleport>
</template>

<script setup lang="ts">
import { useMutation } from '@vue/apollo-composable'
import { WdsButton, WdsModal, WdsStack, WdsText } from '@worksome/wds-components'

import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import NetworkError from '@/utils/notification/NetworkError'
import { DeletePaymentRequestMutation } from '@/components/GraphQL/mutations/PaymentRequests/DeletePaymentRequestMutation'

const props = withDefaults(
  defineProps<{
    open?: boolean
    paymentRequestId: string
  }>(),
  {
    open: false,
  },
)

const emit = defineEmits(['close', 'payment-request-deleted'])

const { loading: deletePaymentRequestLoading, mutate: mutateDeletePaymentRequest } = useMutation(
  DeletePaymentRequestMutation,
  {
    clientId: 'publicApi',
  },
)

const deletePaymentRequest = async () => {
  try {
    await mutateDeletePaymentRequest({
      input: {
        id: props.paymentRequestId,
      },
    })

    emit('payment-request-deleted')
    emit('close')
  } catch (ex: any) {
    new NetworkError({
      ex,
      msg: $t('An error occurred'),
    }).dispatch()
  }
}
</script>

<style scoped lang="scss">
:deep(.wds-modal-header) {
  @apply tw-p-0;
}
</style>
